(() => {
  'use strict';

  if (window.GLLFLavenderCart?.version) return;

  const SELECTOR = '[data-gllf-cart-root]';
  const CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/;
  const CART_READ = () => `${window.Shopify?.routes?.root || '/'}cart.js`;
  const EXCLUDED_COUNT_PRODUCT_IDS = new Set([
    '10405563990312',
    '10405571461416',
    '10417050485032',
    '10417050517800'
  ]);
  const slots = [
    { x: 30, r: -.04, s: 1.02 }, { x: 20, r: -.30, s: .92 },
    { x: 40, r: .30, s: .92 }, { x: 25, r: -.16, s: .84 },
    { x: 35, r: .16, s: .84 }, { x: 16, r: -.43, s: .76 },
    { x: 44, r: .43, s: .76 }
  ];
  const state = { count: 0, total: 0, currency: '', initialized: false };
  const queue = [];
  const pendingOrigins = [];
  let running = false;
  let syncTimer = 0;
  let scheduledOptions = {};

  const roots = () => [...document.querySelectorAll(SELECTOR)];
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: state.currency || window.Shopify?.currency?.active || 'USD'
      }).format(cents / 100);
    } catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  };

  function ellipse(c, x, y, rx, ry, angle, color, alpha = 1) {
    c.save(); c.globalAlpha *= alpha; c.translate(x, y); c.rotate(angle); c.fillStyle = color;
    c.beginPath(); c.ellipse(0, 0, rx, ry, 0, 0, Math.PI * 2); c.fill(); c.restore();
  }

  function drawLavender(c, x, baseY, scale, rotation, progress = 1, alpha = 1) {
    const stemLength = 31 * scale * progress;
    c.save(); c.globalAlpha *= alpha; c.translate(x, baseY); c.rotate(rotation); c.lineCap = 'round';
    for (let i = -2; i <= 2; i += 1) {
      const spread = i * 2.15 * scale;
      const tipX = spread * 1.34;
      const tipY = -stemLength * (.94 + Math.abs(i) * .018);
      c.strokeStyle = i % 2 ? '#71805f' : '#617353';
      c.lineWidth = Math.max(1, 1.15 * scale);
      c.beginPath(); c.moveTo(spread * .2, 1);
      c.quadraticCurveTo(spread * .45, -stemLength * .48, tipX, tipY); c.stroke();
      if (progress > .34) {
        const bloom = Math.min(1, (progress - .34) / .66);
        for (let j = 0; j < 5; j += 1) {
          const t = .58 + j * .082;
          const bx = spread * .2 + (tipX - spread * .2) * t;
          const by = -stemLength * t;
          const side = j % 2 ? 1 : -1;
          const size = (1.45 - j * .05) * scale * bloom;
          ellipse(c, bx + side * 1.45 * scale, by, size, 2.35 * scale, side * .55, '#72578d', bloom);
          ellipse(c, bx - side * .7 * scale, by - 1.1 * scale, size * .82, 2.05 * scale, -side * .42, '#9279aa', bloom);
          ellipse(c, bx, by - 2 * scale, size * .48, 1.25 * scale, 0, '#5d4178', bloom);
        }
      }
    }
    c.restore();
  }

  function drawBasketBack(c) {
    c.save(); c.lineCap = 'round'; c.lineJoin = 'round';
    const handle = c.createLinearGradient(21, 0, 39, 0);
    handle.addColorStop(0, '#d49350'); handle.addColorStop(.44, '#bd7840');
    handle.addColorStop(.72, '#81502f'); handle.addColorStop(1, '#59351f');
    const path = () => {
      c.beginPath(); c.moveTo(22.5, 35); c.lineTo(21.8, 12.5);
      c.bezierCurveTo(21.8, 5.2, 25.7, 3.2, 30, 3.2);
      c.bezierCurveTo(34.3, 3.2, 38.2, 5.2, 38.2, 12.5); c.lineTo(37.5, 34);
    };
    c.strokeStyle = '#56301b'; c.lineWidth = 6; path(); c.stroke();
    c.strokeStyle = handle; c.lineWidth = 4.8; path(); c.stroke();
    c.strokeStyle = 'rgba(255,219,151,.68)'; c.lineWidth = .9;
    c.beginPath(); c.moveTo(22.7, 34); c.lineTo(22, 12.5);
    c.bezierCurveTo(22, 6.3, 25.9, 4.2, 30, 4.2); c.stroke();
    c.fillStyle = '#754426'; c.beginPath(); c.ellipse(30, 31.5, 24, 6.4, 0, 0, Math.PI * 2); c.fill();
    c.fillStyle = '#432a1c'; c.beginPath(); c.ellipse(30, 31, 20.8, 4.25, 0, 0, Math.PI * 2); c.fill();
    c.strokeStyle = '#ba7540'; c.lineWidth = 1.15;
    c.beginPath(); c.ellipse(30, 31, 21.8, 4.9, 0, Math.PI, Math.PI * 2); c.stroke(); c.restore();
  }

  function basketBodyPath(c) {
    c.beginPath(); c.moveTo(6.2, 30.8); c.quadraticCurveTo(30, 38.2, 53.8, 30.8);
    c.quadraticCurveTo(52, 40.5, 47.2, 49.4); c.quadraticCurveTo(45.5, 54.2, 40.8, 55.5);
    c.quadraticCurveTo(30, 58.2, 19.2, 55.5); c.quadraticCurveTo(14.5, 54.2, 12.8, 49.4);
    c.quadraticCurveTo(8, 40.5, 6.2, 30.8); c.closePath();
  }

  function drawBasketFront(c) {
    c.save();
    const wicker = c.createLinearGradient(8, 30, 50, 56);
    wicker.addColorStop(0, '#a55f32'); wicker.addColorStop(.28, '#d28d47');
    wicker.addColorStop(.55, '#e1a65e'); wicker.addColorStop(1, '#8c4c29');
    basketBodyPath(c); c.fillStyle = wicker; c.fill(); c.save(); basketBodyPath(c); c.clip();
    c.strokeStyle = 'rgba(89,48,25,.55)'; c.lineWidth = .8;
    for (let x = 11; x <= 49; x += 7) {
      c.beginPath(); c.moveTo(x, 28); c.quadraticCurveTo(x + (x < 30 ? 2 : -2), 43, x + (x < 30 ? 5 : -5), 57); c.stroke();
    }
    for (let y = 35; y <= 53; y += 4.4) {
      c.strokeStyle = y % 2 < 1 ? 'rgba(247,193,112,.75)' : 'rgba(111,58,28,.58)'; c.lineWidth = 1.35;
      c.beginPath(); c.moveTo(5, y); c.bezierCurveTo(17, y + 2.8, 42, y - 2.2, 55, y + .8); c.stroke();
    }
    c.restore(); c.strokeStyle = '#6f3b20'; c.lineWidth = 3.3;
    c.beginPath(); c.ellipse(30, 30.7, 24, 6.1, 0, 0, Math.PI); c.stroke();
    c.strokeStyle = '#c57d3e'; c.lineWidth = 2.1;
    c.beginPath(); c.ellipse(30, 30.3, 23.4, 5.65, 0, 0, Math.PI); c.stroke();
    const front = c.createLinearGradient(21, 20, 25, 40);
    front.addColorStop(0, '#d18c47'); front.addColorStop(.52, '#efb86a'); front.addColorStop(1, '#92502b');
    c.lineCap = 'round'; c.strokeStyle = '#6e3b20'; c.lineWidth = 6;
    c.beginPath(); c.moveTo(22.15, 21); c.lineTo(22.75, 38.5); c.stroke();
    c.strokeStyle = front; c.lineWidth = 4.7;
    c.beginPath(); c.moveTo(22.15, 21); c.lineTo(22.75, 38.5); c.stroke();
    c.strokeStyle = 'rgba(255,220,151,.68)'; c.lineWidth = .8;
    c.beginPath(); c.moveTo(22.45, 21); c.lineTo(23.05, 38); c.stroke(); c.restore();
  }

  function paint(canvas, count, animatedIndex = -1, progress = 1) {
    if (!canvas?.getContext) return;
    const c = canvas.getContext('2d');
    c.clearRect(0, 0, 120, 120); c.save(); c.scale(2, 2);
    const reaction = animatedIndex >= 0 ? Math.sin(progress * Math.PI) : 0;
    c.translate(30, 43); c.rotate((animatedIndex % 2 ? -.018 : .018) * reaction);
    c.scale(1 + .025 * reaction, 1 - .035 * reaction); c.translate(-30, -43);
    drawBasketBack(c);
    const visible = Math.min(count, slots.length);
    for (let i = 0; i < visible; i += 1) {
      const slot = slots[i];
      drawLavender(c, slot.x, 43, slot.s, slot.r, i === animatedIndex ? progress : 1, i < 3 ? 1 : .93);
    }
    drawBasketFront(c); c.restore();
  }

  function paintAll(animatedIndex = -1, progress = 1) {
    roots().forEach((root) => paint(root.querySelector('[data-gllf-cart-canvas]'), state.count, animatedIndex, progress));
  }

  function announce(text) {
    document.querySelectorAll('[data-gllf-cart-a11y]').forEach((node) => { node.textContent = text; });
  }

  function merchandiseCount(cart) {
    if (!Array.isArray(cart?.items)) return Number(cart?.item_count) || 0;
    return cart.items.reduce((count, item) => {
      const properties = item?.properties || {};
      const handle = String(item?.handle || '');
      if (
        EXCLUDED_COUNT_PRODUCT_IDS.has(String(item?.product_id || '')) ||
        properties['_Protection Type'] ||
        properties['Protection Amount'] ||
        handle === 'shipping-protection' ||
        handle === '1-year-grow-guarantee' ||
        handle === '1-year-plant-warranty'
      ) return count;
      const quantity = Number(item?.quantity);
      return count + (Number.isFinite(quantity) && quantity > 0 ? quantity : 0);
    }, 0);
  }

  function render({ announceChange = false } = {}) {
    const formatted = money(state.total);
    roots().forEach((root) => {
      const badge = root.querySelector('[data-gllf-cart-count]');
      const total = root.querySelector('[data-gllf-cart-total]');
      if (badge) badge.textContent = state.count > 99 ? '99+' : String(state.count);
      if (total) total.textContent = formatted;
    });
    paintAll();
    if (announceChange) announce(`Cart updated. ${state.count} ${state.count === 1 ? 'item' : 'items'}, ${formatted}.`);
  }

  function animateStem(index) {
    if (reducedMotion() || index < 0) { paintAll(); return Promise.resolve(); }
    return new Promise((resolve) => {
      const start = performance.now();
      const frame = (now) => {
        const raw = Math.min(1, (now - start) / 410);
        paintAll(index, 1 - Math.pow(1 - raw, 3));
        if (raw < 1) requestAnimationFrame(frame); else resolve();
      };
      requestAnimationFrame(frame);
    });
  }

  function petals(root) {
    if (reducedMotion() || ![1, 3, 6, 10].includes(state.count)) return;
    const rect = root.getBoundingClientRect();
    for (let i = 0; i < 5; i += 1) {
      const p = document.createElement('i'); p.className = 'gllf-lavender-cart__petal';
      p.style.left = `${rect.left + rect.width / 2}px`; p.style.top = `${rect.top + 18}px`;
      p.style.setProperty('--gllf-x', `${(Math.random() - .5) * 62}px`);
      p.style.setProperty('--gllf-y', `${22 + Math.random() * 36}px`);
      p.style.animationDelay = `${i * 34}ms`; document.body.append(p); setTimeout(() => p.remove(), 900);
    }
  }

  function celebrate() {
    roots().forEach((root) => {
      root.classList.remove('is-celebrating'); void root.offsetWidth;
      root.classList.add('is-celebrating'); petals(root);
      setTimeout(() => root.classList.remove('is-celebrating'), 760);
    });
  }

  function captureOrigin(event) {
    const trigger = event.target?.closest?.(
      '[name="add"], [data-add-to-cart], .add-to-cart, .product-form__submit, form[action*="/cart/add"] button[type="submit"]'
    );
    if (!trigger) return;
    const rect = trigger.getBoundingClientRect();
    pendingOrigins.push({
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
      at: Date.now()
    });
    while (pendingOrigins.length > 12) pendingOrigins.shift();
  }

  function flyBundle(origin) {
    const target = roots()[0]?.querySelector('[data-gllf-cart-canvas]');
    if (!origin || !target || reducedMotion() || Date.now() - origin.at > 8000) return Promise.resolve();
    const to = target.getBoundingClientRect();
    const flight = document.createElement('canvas');
    flight.width = 108; flight.height = 152; flight.className = 'gllf-lavender-cart__flight';
    document.body.append(flight);
    const c = flight.getContext('2d');
    const sx = origin.x - 27; const sy = origin.y - 38;
    const ex = to.left + to.width / 2 - 27; const ey = to.top + to.height * .44 - 38;
    const start = performance.now();
    return new Promise((resolve) => {
      const frame = (now) => {
        const p = Math.min(1, (now - start) / 520);
        const eased = 1 - Math.pow(1 - p, 3);
        const x = sx + (ex - sx) * eased;
        const y = sy + (ey - sy) * eased - Math.sin(Math.PI * eased) * 58;
        flight.style.transform = `translate3d(${x}px,${y}px,0) rotate(${-8 + 14 * eased}deg) scale(${.72 - .26 * eased})`;
        c.clearRect(0, 0, 108, 152); c.save(); c.scale(1.8, 1.8);
        drawLavender(c, 30, 76, 1.35, 0, 1, 1); c.restore();
        if (p < 1) requestAnimationFrame(frame);
        else { flight.remove(); resolve(); }
      };
      requestAnimationFrame(frame);
    });
  }

  async function runQueue() {
    if (running) return;
    running = true;
    while (queue.length) {
      const task = queue.shift();
      const previous = state.count;
      state.count = task.count; state.total = task.total; state.currency = task.currency || state.currency;
      render();
      if (task.animate && state.count > previous) {
        await flyBundle(task.origin);
        const additions = Math.min(state.count - previous, 3);
        for (let i = 0; i < additions; i += 1) {
          await animateStem(Math.min(previous + i, slots.length - 1));
        }
        celebrate();
      }
      render({ announceChange: task.announceChange });
    }
    running = false;
  }

  function applyCart(cart, options = {}) {
    if (!cart) return;
    queue.push({
      count: merchandiseCount(cart), total: Number(cart.total_price) || 0,
      currency: cart.currency || '', animate: options.animate !== false,
      announceChange: options.announceChange !== false, origin: options.origin || null
    });
    runQueue();
  }

  async function refresh(options = {}) {
    clearTimeout(syncTimer);
    try {
      const response = await fetch(CART_READ(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Cart refresh failed: ${response.status}`);
      const cart = await response.json(); applyCart(cart, options); return cart;
    } catch (error) {
      announce('The cart display could not refresh. Open the cart to confirm its contents.');
      document.dispatchEvent(new CustomEvent('gllf:cart:error', { detail: { error } }));
      return null;
    }
  }

  function scheduleRefresh(options = {}) {
    clearTimeout(syncTimer);
    scheduledOptions = { ...scheduledOptions, ...options };
    syncTimer = window.setTimeout(() => {
      const next = scheduledOptions; scheduledOptions = {}; refresh(next);
    }, 80);
  }

  function observeFetch() {
    const nativeFetch = window.fetch;
    if (!nativeFetch || nativeFetch.__gllfCartObserved) return;
    const wrapped = function (...args) {
      const request = args[0];
      const url = typeof request === 'string' ? request : request?.url || '';
      const promise = nativeFetch.apply(this, args);
      if (CART_MUTATION.test(url)) promise.then((response) => {
        if (response.ok) scheduleRefresh({
          animate: true, announceChange: true,
          origin: /\/cart\/add/.test(url) ? pendingOrigins.shift() : null
        });
      }).catch(() => {});
      return promise;
    };
    wrapped.__gllfCartObserved = true; window.fetch = wrapped;
  }

  function observeXHR() {
    const nativeOpen = XMLHttpRequest.prototype.open;
    if (nativeOpen.__gllfCartObserved) return;
    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__gllfCartMutation = CART_MUTATION.test(String(url));
      this.__gllfCartAdd = /\/cart\/add/.test(String(url));
      if (this.__gllfCartMutation) this.addEventListener('loadend', () => {
        if (this.status >= 200 && this.status < 300) scheduleRefresh({
          animate: true, announceChange: true,
          origin: this.__gllfCartAdd ? pendingOrigins.shift() : null
        });
      }, { once: true });
      return nativeOpen.call(this, method, url, ...rest);
    };
    XMLHttpRequest.prototype.open.__gllfCartObserved = true;
  }

  function initialize() {
    const first = roots()[0];
    if (!first) return;
    if (!state.initialized) {
      state.count = Number(first.dataset.gllfInitialCount) || 0;
      state.total = Number(first.dataset.gllfInitialTotal) || 0;
      state.initialized = true; observeFetch(); observeXHR();
      document.addEventListener('click', captureOrigin, true);
      ['cart:updated', 'cart:change', 'cart:refresh', 'ajaxProduct:added'].forEach((name) => {
        document.addEventListener(name, () => scheduleRefresh({ animate: true, announceChange: true }));
      });
      window.addEventListener('pageshow', () => scheduleRefresh({ animate: false, announceChange: false }));
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) scheduleRefresh({ animate: false, announceChange: false });
      });
    }
    render();
  }

  window.GLLFLavenderCart = { version: '1.0.1', refresh, applyCart };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
